import React, { useEffect, useState } from 'react';
import '../DetalleArmonizacionContable/detalleArmonizacionContable.css';

  const DetalleArmonizacionContable2026 = () => {
        useEffect(() => {
          window.scrollTo(0, 0);
  },[]); 

  return (
    <div className='container'>
        <div className='row'>
          <div className='ldf_titulo'>
            <h2>Armonización Contable 2026</h2>
            <hr className='hr-gob'/>
          </div>

            <div style={{ width: "100%" }}>
                <table className="table table-striped table-bordered">
                          <tr>
                            <th scope="col"><div className="detalle_nombreDocumentoAC" style={{ width: "520px" }}>Documento</div></th>
                            <th scope="col"><div style={{ width: "55px" }}>1er_Trim</div></th>
                            <th scope="col"><div style={{ width: "55px" }}>2do_Trim</div></th>
                            <th scope="col"><div style={{ width: "55px" }}>3er_Trim</div></th>
                            <th scope="col"><div style={{ width: "55px" }}>4to_Trim</div></th>
                          </tr>
                </table>
            </div>

            <div className="tabla-contenedorAC">
            <table className="table table-striped table-bordered tabla-elementosAC">
                    <tbody>
                      <tr>
                        <th scope="row" colspan="6"><div className="th-seccion">Información Contable</div></th>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Estado Analítico del Activo</div></th>
                          <td>
                            <div style={{ width: "70px" }}>
                                <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/1erTrim/Estado_Analitico_del_Activo.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                            </div>
                          </td>
                          <td>
                            <div style={{ width: "70px" }}>
                            {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/2doTrim/Estado_Analitico_del_Activo.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                            </div>
                          </td>
                          <td>
                            <div style={{ width: "70px" }}>
                            {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/3erTrim/Estado_Analitico_del_Activo.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                            </div>
                          </td>
                          <td>
                            <div style={{ width: "70px" }}>
                            {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/4toTrim/Estado_Analitico_del_Activo.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                            </div>
                          </td>   
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Estado de Resultados/Actividades</div></th>
                        <td>
                            <div>
                               <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/1erTrim/Estado_de_Actividades.pdf" target="_blank" rel="noopener noreferrer">
                               <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                            </div>
                          </td>
                          <td>
                            <div>
                            {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/2doTrim/Estado_de_Actividades.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                            </div>
                          </td>
                          <td>
                            <div>
                            {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/3erTrim/Estado_de_Actividades.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                            </div>
                          </td>
                          <td>
                            <div>
                            {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/4toTrim/Estado_de_Actividades.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>    */}
                            </div>
                          </td>   
                        </tr>
                        <tr>
                          <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Estado de Flujos de Efectivo</div></th>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/1erTrim/Estado_de_Flujos_de_Efectivo.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   
                            </div>
                          </td>
                          <td>
                            <div>
                              {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/2doTrim/Estado_de_Flujos_de_Efectivo.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                            </div>
                          </td>
                          <td>
                            <div>
                              {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/3erTrim/Estado_de_Flujos_de_Efectivo.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                            </div>
                          </td>
                          <td>
                            <div>
                             {/*   <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/4toTrim/Estado_de_Flujos_de_Efectivo.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                            </div>
                          </td>   
                        </tr>
                        <tr>
                          <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Estado de Cambios en la Situación Financiera</div></th>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/1erTrim/Estado_de_Cambios_en_la_Situacion_Financiera.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                            </div>
                          </td>
                          <td>
                            <div>
                            {/*    <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/2doTrim/Estado_de_Cambios_en_la_Situacion_Financiera.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                            </div>
                          </td>
                          <td>
                            <div>
                            {/*    <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/3erTrim/Estado_de_Cambios_en_la_Situacion_Financiera.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                            </div>
                          </td>
                          <td>
                            <div>
                            {/*    <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/4toTrim/Estado_de_Cambios_en_la_Situacion_Financiera.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                            </div>
                          </td>    
                        </tr>
                        
                        <tr>
                          <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Estado de Situación Financiera</div></th>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/1erTrim/Estado_de_Situacion_Financiera.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   
                            </div>
                          </td>
                          <td>
                            <div>
                            {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/2doTrim/Estado_de_Situacion_Financiera.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                            </div>
                          </td>
                          <td>
                            <div>
                            {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/3erTrim/Estado_de_Situacion_Financiera.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                            </div>
                          </td>
                          <td>
                            <div>
                            {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/4toTrim/Estado_de_Situacion_Financiera.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                            </div>
                          </td>   
                        </tr>
                        <tr>
                          <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Estado de Variación en la Hacienda Pública</div></th>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/1erTrim/Estado_de_Variacion_en_la_Hacienda_Publica.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                            </div>
                          </td>
                          <td>
                            <div>
                            {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/2doTrim/Estado_de_Variacion_en_la_Hacienda_Publica.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                            </div>
                          </td>
                          <td>
                            <div>
                            {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/3erTrim/Estado_de_Variacion_en_la_Hacienda_Publica.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                            </div>
                          </td>
                          <td>
                            <div>
                            {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/4toTrim/Estado_de_Variacion_en_la_Hacienda_Publica.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                            </div>
                          </td>   
                        </tr>      
                        <tr>
                          <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Estado Analítico de la Deuda y Otros pasivos</div></th>
                          <td>
                            <div>
                               <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/1erTrim/Estado_Analitico_de_la_Deuda_y_Otros_Pasivos.pdf" target="_blank" rel="noopener noreferrer">
                               <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   
                            </div>
                          </td>
                          <td>
                            <div>
                            {/*    <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/2doTrim/Estado_Analitico_de_la_Deuda_y_Otros_Pasivos.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */} 
                            </div>
                          </td>
                          <td>
                            <div>
                            {/*    <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/3erTrim/Estado_Analitico_de_la_Deuda_y_Otros_Pasivos.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                            </div>
                          </td>
                          <td>
                            <div>
                            {/*    <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/4toTrim/Estado_Analitico_de_la_Deuda_y_Otros_pasivos.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                            </div>
                          </td>  
                        </tr>
                        <tr>
                          <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Informe de Pasivos Contingentes</div></th>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/1erTrim/Informe_de_Pasivos_Contingentes.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                            </div>
                          </td>
                          <td>
                            <div>
                            {/*    <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/2doTrim/Informe_sobre_Pasivos_Contingentes.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                            </div>
                          </td>
                          <td>
                            <div>
                            {/*    <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/3erTrim/Pasivos_Contingentes.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                            </div>
                          </td>
                          <td>
                            <div>
                            {/*    <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/4toTrim/Informe_de_Pasivos_Contingentes.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                            </div>
                          </td>   
                        </tr>
                        <tr>
                          <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Notas a los Estados Financieros</div></th>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/1erTrim/Notas_a_los_Estados_Financieros.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                            </div>
                          </td>
                          <td>
                            <div>
                            {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/2doTrim/Notas_junio.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                            </div>
                          </td>
                          <td>
                            <div>
                            {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/3erTrim/Notas_a_los_Estados_Financieros.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                            </div>
                          </td>
                          <td>
                            <div>
                            {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/4toTrim/Notas_a_los_Estados_Financieros.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                            </div>
                          </td>  
                        </tr>
                        <tr>
                          <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                          <th scope="row"><div className="div-nombres-elementosAC">Manual de Contabilidad</div></th>
                          <td>
                            <div>
                                <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/1erTrim/MANUAL_DE_CONTABILIDAD_2026.pdf" target="_blank" rel="noopener noreferrer">
                                <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                            </div>
                          </td>
                          <td><div></div></td>
                          <td><div></div></td>
                          <td><div></div></td>
                        </tr>
                      
                      <tr>
                        <th scope="row" colspan="6"><div className="th-seccion">Información Presupuestaria</div></th>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Estado Analítico del Ingreso, clasificación económica por fuente de financiamiento y concepto</div></th>
                       <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/1erTrim/Estado_Analitico_de_Ingresos.pdf" target="_blank" rel="noopener noreferrer">
                            <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                        {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/2doTrim/1Estado_Analitico_de_Ingresos.pdf" target="_blank" rel="noopener noreferrer">
                            <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>
                        </td>
                        <td>
                          <div>
                        {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/3erTrim/Analitico_de_Ingresos.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>
                        </td>
                        <td>
                          <div>
                        {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/4toTrim/ESTADO_ANALITICO_DE_INGRESOS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */} 
                          </div>
                        </td>  
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Estado Analítico del Ejercicio del Presupuesto de Egresos, (Administrativa)</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/1erTrim/EAEPE_Clasificacion_Administrativa.pdf" target="_blank" rel="noopener noreferrer">
                              <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                        {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/2doTrim/EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacion_Administrativa.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>
                        </td>
                        <td>
                          <div>
                        {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/3erTrim/Clasificacion_Administrativa.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>
                        </td>
                        <td>
                          <div>
                        {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/4toTrim/EAEPE_CLASIF._ADMINISTRATIVA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>
                        </td>  
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Estado Analítico del Ejercicio del Presupuesto de Egresos. Clasificación Económica por tipo de Gasto</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/1erTrim/EAEPE_Clasificacion_Economica.pdf" target="_blank" rel="noopener noreferrer">
                              <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                        {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/2doTrim/EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacionEconomica(Por_Tipo_de_Gasto).pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>
                        </td>
                        <td>
                          <div>
                        {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/3erTrim/Clasificacion_Economica.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                          </div>
                        </td>
                        <td>
                          <div>
                        {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/4toTrim/EAEPE_CLASIF._ECONOMICA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>
                        </td>  
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Estado Analítico del Ejercicio del Presupuesto de Egresos. Clasificación por objeto del gasto</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/1erTrim/EAEPE_Clasificacion_por_Objeto_del_Gasto.pdf" target="_blank" rel="noopener noreferrer">
                              <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                        {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/2doTrim/EstadoAnaliticoEjercicioPresupuestoEgresosClasificacionObjetoDelGasto(CapituloYConcepto).pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>
                        </td>
                        <td>
                          <div>
                         {/*   <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/3erTrim/Clasificacion_por_Objeto_del_Gasto.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>
                        </td>
                        <td>
                          <div>
                          {/*  <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/4toTrim/EAEPE_COG.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>
                        </td>  
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Estado Analítico del Ejercicio del Presupuesto de Egresos. Clasificación Funcional</div></th>
                        <td>
                          <div>
                           <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/1erTrim/EAEPE_Clasificacion_Funcional.pdf" target="_blank" rel="noopener noreferrer">
                            <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                        {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/2doTrim/EstadoAnaliticodelEjerciciodelPresupuestodeEgresosClasificacionFuncional(Finalidad_y_Funcion).pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>
                        </td>
                        <td>
                           <div>
                         {/*   <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/3erTrim/Clasificacion_Funcional.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>
                        </td>
                        <td>
                          <div>
                        {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/4toTrim/EAEPE_CLASIF._FUNCIONAL.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>
                        </td>  
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Endeudamiento Neto</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/1erTrim/Endeudamiento_Neto.pdf" target="_blank" rel="noopener noreferrer">
                              <button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div>
                        </td>
                        <td>
                          <div>
                         {/*   <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/2doTrim/Endeudamiento_Neto.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td>
                        <td>
                          <div>
                         {/*   <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/3erTrim/Endeudamiento_Neto.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                          </div>
                        </td>
                        <td>
                        <div>
                         {/*   <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/4toTrim/ENDEUDAMIENTO_NETO.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>   
                        </td>  
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Intereses de la Deuda</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/1erTrim/Intereses_de_la_Deuda.pdf" target="_blank" rel="noopener noreferrer">
                              <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   
                          </div>
                        </td>
                        <td>
                          <div>
                         {/*   <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/2doTrim/Intereses_de_la_Deuda.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>    */}
                          </div>
                        </td>
                        <td>
                          <div>
                         {/*   <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/3erTrim/Intereses_de_la_Deuda.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */} 
                          </div>
                        </td>
                        <td>
                          <div>
                         {/*   <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/4toTrim/INTERESES_DE_LA_DEUDA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                          </div>
                        </td>  
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Flujo de Fondos</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/1erTrim/Flujo_de_Fondos.pdf" target="_blank" rel="noopener noreferrer">
                              <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   
                          </div>
                        </td>
                        <td>
                          <div> 
                        {/*    <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/2doTrim/Flujo_de_Fondos.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>    */}
                          </div>
                        </td>
                        <td>
                          <div>
                        {/*    <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/3erTrim/Flujo_de_Fondos.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>    */}
                          </div>
                        </td>
                        <td>
                          <div>
                          {/*  <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/4toTrim/FLUJO_DE_FONDOS.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>
                        </td>  
                      </tr>
                     
                      <tr>
                        <th scope="row" colspan="6"><div className="th-seccion">Información Programática</div></th>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Gasto por Categoría Programática</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/1erTrim/Gasto_por_Categoria_Programatica.pdf" target="_blank" rel="noopener noreferrer">
                              <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                         {/*   <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/2doTrim/Gasto_por_Categoria_Programatica.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                          </div>
                        </td>
                        <td>
                          <div>
                         {/*   <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/3erTrim/Gasto_por_Categoria_Programatica.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                          </div>
                        </td>
                        <td>
                          <div>
                          {/*   <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/4toTrim/GASTO_POR_CATEGORIA_PROGRAMATICA.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>    */}
                          </div>
                        </td> 
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Indicadores de Resultados</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/1erTrim/IR-UTEED-1erTrim2026.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                          {/*   <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/2doTrim/IR_2doTrim_2025.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>
                        </td>
                        <td>
                          <div>
                          {/*   <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/3erTrim/IR_3erTrim_2025.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>
                        </td>
                        <td>
                          <div>
                          {/*   <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/4toTrim/IR-UTEED-4toTrim2025.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>
                        </td> 
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Programas y Proyectos de Inversión</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/1erTrim/Programas_y_Proyectos_de_Inversion.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   
                          </div>
                        </td>
                        <td>
                          <div>
                        {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/2doTrim/Programas_y_Proyectos_de_Inversion.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                          </div>
                        </td>
                        <td>
                          <div>
                        {/*    <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/3erTrim/Programas_y_Proyectos_de_Inversion.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                          </div>
                        </td>
                        <td>
                          <div>
                         {/*   <a href="http://dif.hidalgo.gob.mx/pdf/share_AC_IGFC/2026/4toTrim/Programas_y_Proyectos_de_Inversion.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */} 
                          </div>   
                        </td>  
                      </tr> 
              
                      <tr>
                        <th scope="row" colspan="6"><div className="th-seccion">Inventarios</div></th>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Inventario de Bienes Muebles</div></th>
                        <td>
                          <div>
                         {/*   <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/1erTrim/RBMI_DIF_1ER_TRIM_2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>   
                        </td>
                        <td>
                          <div>
                        {/*    <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/2doTrim/BIENES_MUEBLES_2doTRIM_2025.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                          </div>   
                        </td>
                        <td>
                          <div>
                         {/*   <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2023/3erTrim/RBMI_DIF_03_2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>  
                        </td>
                        <td>
                          <div>
                          {/*  <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/4toTrim/CACEH.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                          </div>  
                        </td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Inventario de Bienes Inmuebles</div></th>
                        <td>
                          <div>
                          {/*  <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/1erTrim/IBIM_DIF_01_2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>  
                        </td>
                        <td>
                         <div>
                          {/*   <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/2doTrim/Inventario_Inmuebles_2025.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>  
                        </td>
                        <td>
                          <div>
                          {/*  <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/3erTrim/Inventario_de_Bienes-Inmuebles-3erTrim2024.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> */}
                          </div>  
                        </td>
                        <td>
                          <div>
                         {/*   <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/4toTrim/Bienes_Inmuebles_4toTrim.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                          </div>  
                        </td>
                      </tr>
                      
                      <tr>
                        <th scope="row" colspan="6"><div className="th-seccion">Información Adicional</div></th>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Información para la Difusión de la Ley de Ingresos y del Presupuesto de Egresos</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/1erTrim/Norma_para_la_difusion_a_la_ciudadania_de_la_Ley_de_Ingresos_y_del_Presupuesto_de_Egresos_2019_NOR_01_14_003.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div> 
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Información del Calendario de Ingresos base mensual</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/1erTrim/Estructura_del_Calendario_de_Ingresos_base_mensual_NOR_01_14_004.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div> 
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Información del Calendario de Egresos base mensual</div></th>
                        <td>
                         <div>
                           <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/1erTrim/Calendario_del_presupuesto_de_Egresos_del_ejercicio_fiscal_NOR_01_14_005.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div> 
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Información Adicional a la Iniciativa de la Ley de Ingresos</div></th>
                        <td>
                        <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/1erTrim/Información_adicional_a_la_iniciativa_de_la_Ley_de_Ingreos_NOR_01_14_001.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div> 
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Información Adicional al Proyecto de Presupuesto de Egresos</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/1erTrim/Informacion_adicional_al_proyecto_del_Presupuesto_de_Egresos.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a> 
                          </div> 
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Calendario de Programación Presupuestal</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/1erTrim/Calendario_del_Gasto_1Trim2026.pdf" target="_blank" rel="noopener noreferrer">
                              <button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>  
                        </td>
                        <td>
                          <div>
                        {/*    <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/2doTrim/Calendario_del_Gasto_2Trim_2025.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>
                        </td>
                        <td>
                          <div>
                        {/*    <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/3erTrim/Calendario_del_Gasto_3erTrim_2025.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>
                        </td>
                        <td>
                          <div>
                        {/*    <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/4toTrim/Calendario_del_Gasto_4toTrim2025.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>
                        </td>
                      </tr>
                      
                      <tr>
                        <th scope="row" colspan="6"><div className="th-seccion">Normas</div></th>
                      </tr>
                      <tr>
                        <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                        <th scope="row"><div className="div-nombres-elementosAC">Montos Pagados por Ayudas y Subsidios</div></th>
                        <td>
                          <div>
                            <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/1erTrim/Formato_MPAS_1ER_TRIM_2026.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  
                          </div>
                        </td>
                        <td>
                          <div>
                        {/*    <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/2doTrim/Formato_MPAS_2DO_TRIM_2025.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>  */}
                          </div>
                        </td>
                        <td>
                          <div>
                        {/*    <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/3erTrim/Formato_MPAS_3er_TRIM_2025.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                          </div>
                        </td>
                        <td>
                          <div>
                        {/*    <a href="http://dif.hidalgo.gob.mx/armonizacion_contable/2026/4toTrim/Montos_Pagados_por_Ayudas_y_Subsidios.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>   */}
                          </div>
                        </td>  
                      </tr>
                    </tbody>
              </table>
            </div>

          </div>
      </div>
    
  )
}

  export default DetalleArmonizacionContable2026